import React, { useEffect, useMemo, useState } from 'react';
import { useRouter } from 'next/router';
import { useProductDispatch } from '../../ProductProvider';
import { useNavGoTop } from '../index';
import ConsultingDialog from './ConsultingDialog';
import styles from './index.module.scss';
import { US_Info_Data } from './common';
import DeviceSwiper from './DeviceSwiper';
import { getSolarRecommand } from '@/service/solar-calculator';
import { useGlobal } from '@/utils/useGlobal';

const HeadDevice: React.FC = () => {
    const { gtm, useLang } = useGlobal();
    const { locale, query } = useRouter();
    const { t: s } = useLang('shared.product.info');
    const { t: m } = useLang('shared.product.menu');
    const dispatch = useProductDispatch();
    const btn1Text = useMemo(() => {
        if (locale !== 'us') return 'Buy Now';
        //   2. 北京时间 11/30 15:00起：Buy Now
        const now = query._timer ? new Date(query._timer as string) : new Date();
        const buyNowTime = new Date('2024/12/10 16:00:00 GMT+8');
        if (now < buyNowTime) {
            return 'Pre-Order';
        }
        if (now >= buyNowTime) {
            return 'Buy Now';
        }
    }, [locale, query._timer]);

    const [curDialog, setCurDialog] = useState(0);
    const [showIconDialog, setShowIconDialog] = useState(false);
    const [showBtnDialog, setShowBtnDialog] = useState(false);
    useEffect(() => {
        if (query.quote === '1') {
            setShowBtnDialog(true);
        }
    }, [query.quote]);

    // 获取产品信息
    const [productInfo, setProductInfo] = useState({
        price: '',
        compareAtPrice: '',
    });
    useEffect(() => {
        const getProductInfo = async () => {
            try {
                const res = await getSolarRecommand({ productId: '7352587878473', variantId: '41830211747913' }, locale);
                if (res?.code === '0') {
                    setProductInfo(res.data);
                }
            } catch (error) {}
        };
        getProductInfo();
    }, [locale]);

    const handleClickQuote = () => {
        setShowBtnDialog(true);
        gtm.push({
            event: 'uaEvent',
            event_name: 'click_get_a_quote',
            product_name: 'EcoFlow Power Kits 5kVA 48V Power System',
            position: 'Introduction',
            option_name: 'Get a Free Quote',
        });
    };

    // buyNow
    const { handleGoTop } = useNavGoTop();
    const handleClickBuyNow = () => {
        dispatch({
            type: 'changeProductTabActive',
            payload: 'Bundles',
        });
        gtm.push({
            event: 'uaEvent',
            event_name: 'click_anchor',
            position: m('tab_bundles'),
            button_name: s('buy_now'),
        });
        // 切换时划回顶部
        handleGoTop();
    };
    return (
        <>
            <div className={styles.TheComp} id="head-device-container">
                <div className="head-device-container">
                    <div className="head-device-imgs">
                        <DeviceSwiper />
                    </div>
                    <div className="head-device-info">
                        <div className="head-info-launch">{US_Info_Data.tag}</div>
                        <div className="head-info-title">{US_Info_Data.title}</div>
                        <div className="head-info-desc">{US_Info_Data.desc}</div>
                        <ul className="head-info-tips">
                            {US_Info_Data.tips.map((i, idx) => (
                                <li key={idx}>{i}</li>
                            ))}
                        </ul>
                        <div className="head-info-price">
                            <span className="head-info-price-new">${productInfo?.price}</span>
                            {productInfo?.compareAtPrice !== productInfo?.price && <span className="head-info-price-old">${productInfo?.compareAtPrice}</span>}
                            <span className="head-info-price-label">Start From</span>
                        </div>
                        <div className="head-info-cards">
                            {US_Info_Data.icons.map((i, idx) => (
                                <div className="head-info-card-item" key={idx}>
                                    {i.icon}
                                    <span
                                        className={i.Popup ? 'has-dialog' : ''}
                                        onClick={
                                            i.Popup
                                                ? () => {
                                                      setShowIconDialog(true);
                                                      setCurDialog(idx);
                                                      gtm.push({
                                                          event: 'uaEvent',
                                                          event_name: 'product_preview_page',
                                                          button_name: i.title,
                                                          list_name: 'none',
                                                      });
                                                  }
                                                : undefined
                                        }
                                    >
                                        {i.title}
                                    </span>
                                    {i.Popup && showIconDialog && curDialog === idx && (
                                        <i.Popup
                                            callInstallation={setShowIconDialog}
                                            listTitle={i.listTitle}
                                            numList={i.numList}
                                            desc={i.desc}
                                            list={i.list}
                                            title={i.dialogTitle}
                                        />
                                    )}
                                </div>
                            ))}
                        </div>
                        <div className="head-info-btns">
                            <button className="btn-buyNow" onClick={handleClickBuyNow}>
                                {btn1Text}
                            </button>
                            <button className="btn-help" onClick={handleClickQuote}>
                                Get a Free Consultation
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <ConsultingDialog show={showBtnDialog} onClose={() => setShowBtnDialog(false)} />
        </>
    );
};
export default HeadDevice;
